// French for the MOMENTUM zone: the weekly strip, its legend and the three figures.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Momentum': 'Momentum',
  'weekly contact since {date}': 'contact hebdomadaire depuis {date}',
  'no dated evidence': 'aucune preuve datée',
  'The strip appears once there are 5 touches over 8 weeks.': 'Le bandeau apparaît dès que 5 contacts sont enregistrés sur 8 semaines.',
  '{date} · {docs} documents, {events} events': '{date} · {docs} documents, {events} événements',
  '{n} weeks': '{n} semaines',
  'bar height = documents + events that week': 'hauteur de barre = documents + événements de la semaine',
  '{n} days of contact': '{n} jours de contact',
  'days since last contact': 'jours depuis le dernier contact',
  'longest silence, in days': 'silence radio le plus long, en jours',
  'events on the record': 'événements au dossier',
}, 'ClientMomentum');
